import script from "./sqDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./sqDetail.vue?vue&type=script&setup=true&lang=js"

import "./sqDetail.vue?vue&type=style&index=0&id=d777e60c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d777e60c"]])

export default __exports__